var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3408_11391",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3408_11391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.5C8.0375 13.5 7.8595 13.428 7.716 13.284C7.572 13.1405 7.5 12.9625 7.5 12.75C7.5 12.5375 7.572 12.3595 7.716 12.216C7.8595 12.072 8.0375 12 8.25 12H9.75C9.9625 12 10.1408 12.072 10.2848 12.216C10.4283 12.3595 10.5 12.5375 10.5 12.75C10.5 12.9625 10.4283 13.1405 10.2848 13.284C10.1408 13.428 9.9625 13.5 9.75 13.5H8.25ZM3 6C2.7875 6 2.6095 5.92825 2.466 5.78475C2.322 5.64075 2.25 5.4625 2.25 5.25C2.25 5.0375 2.322 4.85925 2.466 4.71525C2.6095 4.57175 2.7875 4.5 3 4.5H15C15.2125 4.5 15.3905 4.57175 15.534 4.71525C15.678 4.85925 15.75 5.0375 15.75 5.25C15.75 5.4625 15.678 5.64075 15.534 5.78475C15.3905 5.92825 15.2125 6 15 6H3ZM5.25 9.75C5.0375 9.75 4.85925 9.678 4.71525 9.534C4.57175 9.3905 4.5 9.2125 4.5 9C4.5 8.7875 4.57175 8.60925 4.71525 8.46525C4.85925 8.32175 5.0375 8.25 5.25 8.25H12.75C12.9625 8.25 13.1405 8.32175 13.284 8.46525C13.428 8.60925 13.5 8.7875 13.5 9C13.5 9.2125 13.428 9.3905 13.284 9.534C13.1405 9.678 12.9625 9.75 12.75 9.75H5.25Z",
    fill: "var(--color-primary)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFilter);
export default __webpack_public_path__ + "static/media/BlueFilter.104cca2f.svg";
export { ForwardRef as ReactComponent };